import { sanitizeName } from '../utils/utils';
import { pushEventsToAnalytics } from '../utils/analyticsEvents';

import { dispatch } from '../store/store-utils';
import { updateCsrf } from '../store/reducers/initialdata-reducer';

import {
  mixpanelAlias,
  mixpanelTrack,
  mixpanelPeople,
  mixpanelRegister
} from '../utils/mixpanelEvents';
import fetcher from './fetch';
import * as validator from './validationV2';

let referralPath = '';

let selectedPlan = '';

let univName = '';

let temp = {};

const csrfToken = document.querySelector('#csrf_token').innerHTML;

const csrfHeader = document.querySelector('#csrf_header').innerHTML;

dispatch(
  updateCsrf({
    csrfToken: `${csrfToken}`,
    csrfHeader: `${csrfHeader}`
  })
);
document.querySelector('#csrf_header').remove();
document.querySelector('#csrf_token').remove();

const htmlDecode = (actValue) => {
  const txt = document.createElement('textarea');
  txt.innerHTML = actValue;

  return txt.value;
};

const signUp = async () => {
  try {
    const user = {};
    const name = document.getElementById('name');
    const mail = document.getElementById('email');
    const password = document.getElementById('password');

    const splitValue = name.value.split(' ');

    for (let i = 0; i < splitValue.length; i += 1) {
      if (i === 0) user.firstName = splitValue[i];
      else {
        user.lastName = name.value.replace(splitValue[0], '').trimStart();
        break;
      }
    }

    user.email = mail.value;
    user.password = password.value;

    if (!validator.validName(name.value, user.firstName, user.lastName, name)) {
      return false;
    }
    if (!validator.validEmail(user.email, mail)) {
      return false;
    }
    if (!validator.validatePassword(user.password, password, true)) {
      return false;
    }

    user.firstName = sanitizeName(user.firstName);
    user.lastName = user.lastName ? sanitizeName(user.lastName) : user.lastName;
    const details = {};

    details.userDetails = user;

    details.referralPath = referralPath;

    console.log(`selectedPlan::${selectedPlan}`);

    console.log(`referralPath:: ${referralPath}  ${htmlDecode(referralPath)}`);

    details.accountDetails = {
      country: temp.countryCode,
      city: temp.cityCode,
      selectedPlan
    };

    const button = document.querySelector('.button');

    button.classList.add('loader');

    const response = await fetcher('POST', '/api/v1/signup', details);
    const resp = await JSON.parse(response);

    button.classList.remove('loader');

    if (resp.status && resp.data.link && resp.data.userDTO) {
      const category =
        univName !== '' && univName !== undefined && univName !== null
          ? univName
          : '';

      if (category !== '') {
        pushEventsToAnalytics(category, 'Signed up', 'User Joined');
      } else {
        pushEventsToAnalytics('AdaptiveU', 'Signed up', 'Account Created');

        mixpanelAlias(resp.data.userDTO);
        mixpanelTrack('Sign up');
        mixpanelRegister({ 'Plan type': 'Free' });
        mixpanelPeople({
          'Plan type': 'Free',
          $name: resp.data.userDTO.name,
          $email: resp.data.userDTO.email
        });
      }

      window.location = resp.data.link;

      return true;
    }

    const element = document.getElementById('error');

    if (element) {
      if (resp.msg) {
        if (resp.msg === 'Please enter a valid name!') {
          validator.showErrorMessageAndAddErrorClass(
            document.getElementsByClassName('name')[0],
            resp.msg
          );
        } else if (resp.msg === 'Please enter a valid email!') {
          validator.showErrorMessageAndAddErrorClass(
            document.getElementsByClassName('email')[0],
            resp.msg
          );
        } else if (resp.msg === 'Please enter a valid password!') {
          validator.showErrorMessageAndAddErrorClass(
            document.getElementsByClassName('password')[0],
            resp.msg
          );
        } else if (
          resp.msg ===
            'Your request is in pending, please wait until admin approves your request' ||
          resp.msg ===
            'Verification email has been sent, please check your email'
        ) {
          element.classList.add('success');

          element.innerHTML = resp.msg;

          element.classList.add('show');

          mail.value = '';

          name.value = '';

          password.value = '';
        } else {
          element.innerHTML = resp.msg;

          element.classList.remove('success');

          element.classList.add('show');
        }
      }
    }
  } catch (err) {
    console.log(err);
  }
  return false;
};

const oauth = (type) => {
  if (type != null && type !== undefined) {
    let location = `/Oauth/${type}?referrer=`;
    if (referralPath !== null && referralPath !== 'undefined')
      location += referralPath;
    else location += '';
    location += `&selectedPlan=${selectedPlan}`;

    window.location = location;
  }
};

const onBlurForEmail = (event, emailElement) => {
  try {
    if (
      event.type === 'focus' ||
      (event.type === 'blur' && emailElement.value.trim() === '')
    )
      document.getElementsByClassName('email')[0].classList.remove('error');
    else if (!validator.validEmail(emailElement.value.trim(), emailElement))
      return false;

    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
};

const onBlurForPassword = (event, password) => {
  try {
    if (
      event.type === 'focus' ||
      (event.type === 'blur' && password.value.trim() === '')
    )
      document.getElementsByClassName('password')[0].classList.remove('error');
    else if (!validator.validatePassword(password.value.trim(), password, true))
      return false;

    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
};

const onBlurForName = (event, name) => {
  try {
    const splitValue = name.value.split(' ');

    let firstName = '';

    let lastName = '';

    for (let i = 0; i < splitValue.length; i += 1) {
      if (i === 0) firstName = splitValue[i];
      else {
        lastName = name.value.replace(splitValue[0], '').trimStart();
        break;
      }
    }

    if (
      event.type === 'focus' ||
      (event.type === 'blur' && name.value.trim() === '')
    ) {
      document.getElementsByClassName('name')[0].classList.remove('error');
    } else if (!validator.validName(name.value, firstName, lastName, name))
      return false;

    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
};

const bindEventsForInputAndButton = () => {
  document.getElementById('password').addEventListener('keypress', (event) => {
    if (event.keyCode === 13) {
      signUp();
    }
  });

  document
    .getElementById('acc_submit')
    .addEventListener('keypress', (event) => {
      if (event.keyCode === 13) {
        signUp();
      }
    });

  document.getElementById('acc_submit').addEventListener('click', signUp);

  const googleSignUp = document.getElementById('google_sign_up');
  googleSignUp.addEventListener('click', async () => {
    if (googleSignUp.hasAttribute('data-type')) {
      const dataType = await googleSignUp.getAttribute('data-type');
      oauth(dataType);
    }
  });

  document.querySelector('.login_btn').addEventListener('click', (e) => {
    e.preventDefault();

    if (referralPath && referralPath !== '' && referralPath != null) {
      window.location = `/login?referrer=${referralPath}`;
    } else window.location = '/login';
  });

  const name = document.getElementById('name');
  name.addEventListener('blur', (event) => {
    onBlurForName(event, name);
  });

  const password = document.getElementById('password');
  password.addEventListener('blur', (event) => {
    onBlurForPassword(event, password);
  });

  const email = document.getElementById('email');
  email.addEventListener('blur', (event) => {
    onBlurForEmail(event, email);
  });
};

const sanitizedSignupObj = (signupDTO) => {
  for (const key in signupDTO) {
    if (
      Object.prototype.hasOwnProperty.call(signupDTO, key) &&
      signupDTO[key] != null &&
      signupDTO[key] !== 'undefined'
    ) {
      signupDTO[key] = sanitizeName(signupDTO[key]);
    }
  }
};

const redirectToLogin = () => {
  const currentUrl = new URL(window.location.href);
  currentUrl.pathname = currentUrl.pathname.replace('/signup', '/login');
  currentUrl.search = '';
  currentUrl.hash = '';
  window.location.href = currentUrl.href;
};

const getEmailFromId = async (signupDTO) => {
  try {
    if (signupDTO.id) {
      signupDTO.email = '';
      const response = await fetcher(
        'GET',
        `/api/v1/invitedUser/email?id=${signupDTO.id}`
      );
      const resp = await JSON.parse(response);
      if (!resp.status) {
        redirectToLogin();
        return;
      }
      signupDTO.email = resp.data.email;
    }
  } catch (error) {
    console.error('Error fetching email:', error);
  }
};

const getSignupObj = async () => {
  const signupDTO = JSON.parse(temp.children[1].innerHTML);
  await sanitizedSignupObj(signupDTO);
  await getEmailFromId(signupDTO);
  return signupDTO;
};

const startup = async () => {
  try {
    let trackName;
    let statusMsg;
    let email;
    let uniqueId = null;

    temp = document.getElementById('temp');

    if (
      temp &&
      temp.children[0] &&
      temp.children[0].innerHTML !== '' &&
      temp.children[1] &&
      temp.children[1].innerHTML !== ''
    ) {
      const signupDTO = await getSignupObj();
      if (signupDTO != null) {
        referralPath =
          signupDTO.referralPath != null &&
          signupDTO.referralPath !== 'undefined'
            ? htmlDecode(signupDTO.referralPath)
            : '';

        univName =
          signupDTO.univName != null && signupDTO.univName !== 'undefined'
            ? signupDTO.univName
            : '';

        trackName =
          signupDTO.trackName != null && signupDTO.trackName !== 'undefined'
            ? signupDTO.trackName
            : '';

        statusMsg =
          signupDTO.statusMsg != null && signupDTO.statusMsg !== 'undefined'
            ? signupDTO.statusMsg
            : '';

        email =
          signupDTO.email != null && signupDTO.email !== 'undefined'
            ? signupDTO.email
            : '';

        uniqueId = signupDTO.id;

        selectedPlan =
          signupDTO.selectedPlan && signupDTO.selectedPlan !== 'undefined'
            ? signupDTO.selectedPlan
            : 'free';
      }

      const homeDTO = JSON.parse(temp.children[0].innerHTML);
      window.environment = homeDTO.pageDTO.environment;
    }

    const firstInput = document.getElementsByTagName('input')[0];

    if (firstInput) {
      firstInput.focus();
    }

    const emailElement = document.getElementById('email');
    if (email && email !== 'undefined') {
      emailElement.focus();
      emailElement.value = htmlDecode(email);
      emailElement.disabled = !!uniqueId;
    }

    if (univName) {
      const signupHeader = document.querySelector('.signup_heading');

      if (signupHeader) {
        signupHeader.querySelector('h1').innerHTML = htmlDecode(univName);
        if (trackName && trackName !== 'undefined')
          signupHeader.querySelector('span').innerHTML = htmlDecode(trackName);
        else if (signupHeader.querySelector('span'))
          signupHeader.querySelector('span').remove();
      }
    }

    if (statusMsg) {
      const element = document.getElementById('error');

      if (element) {
        document.getElementById('error').innerHTML = statusMsg;

        element.classList.add('show');
      }
    }
  } catch (err) {
    console.log(err);
  }
};

(() => {
  bindEventsForInputAndButton();
  startup();
})();
